
import { Dialog, Toast, ActionSheet } from "vant";
import { Component, Vue } from "vue-property-decorator";
Vue.use(ActionSheet);
@Component({
  components: {},
})
export default class Logout extends Vue {
  public shows = false;
  public payList = [
    {
      id: 1,
      img: "/static/img/Alipay.png",
      title: "支付宝支付",
      save: false,
      money: "100",
    },
    {
      id: 2,
      img: "/static/img/WeChat.png",
      title: "微信支付",
      save: false,
      money: "100",
    },
    {
      id: 3,
      img: "/static/img/balance.png",
      title: "账户余额",
      save: false,
      money: "100",
    },
    {
      id: 4,
      img: "/static/img/gold.png",
      title: "金币",
      save: false,
      money: "900",
    },
  ];
  public show(item, boer) {
    this.shows = boer;
  }
  public addPay(item) {
    this.payList.forEach((items) => {
      items.save = false;
    });
    item.save = true;
    Toast("Pay for failure");
    setTimeout(() => {
      this.shows = false;
    }, 1000);
  }
}
